import React,{Component} from 'react';
import classes from './Modal.css';
import Aux from '../../../hoc/Aux';
import BackDrop from '../backdrop/Backdrop'

class Modal extends Component{

	shouldComponentUpdate(prevProp, nextState){
		return (prevProp.show !== this.props.show || prevProp.children !== this.props.chidren)
	}

	render(){
		return (
				<Aux>
				<BackDrop show={this.props.show} click={this.props.click}/>
				<div className={`${classes.Modal} ${classes.MarginTop}`}>
					{this.props.children}
				</div>
		
				</Aux>
			)
		}
}

export default Modal;


// WEBPACK FOOTER //
// ./src/components/UI/modal/Modal.jsx